const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};

function checkWizzyConfigAndUpdate() {
  console.log(window.wizzyConfig.common);
  window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push(
    "#content"
  );
  window.wizzyConfig && clearInterval(interval);
}
var interval = setInterval(checkWizzyConfigAndUpdate, 10);

window.onWizzyScriptLoaded = function () {

  replaceTemplate("wizzy-search-results-product");
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      payload.common.lazyDOMConfig.contentDOMIdentifiers.push("#content");
      return payload;
    }
  );
  wizzymobilepopup();
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      $(".wizzy-search-back span").click();
      // $('#search').removeClass("display-block");
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((product) => {
        if (product.discount === "0.00") {
          product.DiscountID = 0;
        } else {
          product.DiscountID = 1;
        }
      });
      console.log(payload);
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      payload.forEach((product) => {
        let attri = product.attributes;
        attri.forEach((attribute) => {
          // let val = attribute.values;
          // val.forEach((variation)=>{
          //   let varID = variation.variationId;
          // })
          // if(attribute.id === ""){
          //   product.new = attribute.id;
          // }
          // else{
          let val = attribute.values;

          if (attribute.id === "product_variant_ids") {
            product.variationId = attribute.values[0].value[0];
          }

          // }
        });
      });
      console.log(payload);
      return payload;
    }
  );
  wizzymobilearrow();
};

function wizzymobilepopup() {
  document
    .querySelector(".hidden-search-container--mob-only a")
    .addEventListener("click", function (e) {
      e.preventDefault();
      // $('#search').addClass("display-block");
      document.querySelector("#search").click();
      e.stopPropogation();
      e.stopImmediatePropogation();
    });
}
function wizzymobilearrow() {
  $(document).ready(function () {
    if (screen.width < 768) {
      $("body").on("click", ".autocomplete-text-wrapper", function (e) {
        // isFromAutocompleteWrapper = true;
        e.preventDefault();
        var query = $(this).parent().attr("data-searchterm");
        $("#search").val(query);
        e.stopPropagation();
        e.stopImmediatePropagation();
        // var query = $(this).parent().attr("data-searchterm");
        // $(‘#search’).val(query);
      });
    }
  });
}
function wizzysearchscroll() {
  console.log("amananamana");
  $(window).scroll(function () {
    console.log($("body").hasClass("scrolled-top"));
    if ($("body").hasClass("scrolled-top")) {
      console.log("xyxyxyxyxyxyx");
      $(".wizzy-autocomplete-wrapper.onLeft").removeClass("topdist");
    } else {
      console.log("efefefefefefef");
      $(".wizzy-autocomplete-wrapper.onLeft").addClass("topdist");
    }
  });
  // if($(".template-collection.cc-animate-enabled").hasClass("scrolled-top")){
  //     console.log("xyxyxyxyxyxyx");
  //     $(".wizzy-autocomplete-wrapper.onLeft").removeClass("topdist");
  // }
  // else{
  //     console.log("efefefefefefef");
  //     $(".wizzy-autocomplete-wrapper.onLeft").addClass("topdist");
  // }
}

wizzymobilepopup();
